/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateEnumerationEvaluationOptionDtoEvaluationState } from './CreateEnumerationEvaluationOptionDtoEvaluationState';
import {
    CreateEnumerationEvaluationOptionDtoEvaluationStateFromJSON,
    CreateEnumerationEvaluationOptionDtoEvaluationStateFromJSONTyped,
    CreateEnumerationEvaluationOptionDtoEvaluationStateToJSON,
} from './CreateEnumerationEvaluationOptionDtoEvaluationState';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';

/**
 * 
 * @export
 * @interface EnumerationEvaluationOptionDto
 */
export interface EnumerationEvaluationOptionDto {
    /**
     * 
     * @type {number}
     * @memberof EnumerationEvaluationOptionDto
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof EnumerationEvaluationOptionDto
     */
    name?: string | null;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof EnumerationEvaluationOptionDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {boolean}
     * @memberof EnumerationEvaluationOptionDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {CreateEnumerationEvaluationOptionDtoEvaluationState}
     * @memberof EnumerationEvaluationOptionDto
     */
    evaluationState?: CreateEnumerationEvaluationOptionDtoEvaluationState | null;
    /**
     * 
     * @type {string}
     * @memberof EnumerationEvaluationOptionDto
     */
    $type?: EnumerationEvaluationOptionDtoTypeEnum;
}


/**
 * @export
 */
export const EnumerationEvaluationOptionDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoEvaluationParametersEnumerationEvaluationOptionDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.EvaluationParameters.EnumerationEvaluationOptionDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type EnumerationEvaluationOptionDtoTypeEnum = typeof EnumerationEvaluationOptionDtoTypeEnum[keyof typeof EnumerationEvaluationOptionDtoTypeEnum];



/**
 * Check if a given object implements the EnumerationEvaluationOptionDto interface.
 */
export function instanceOfEnumerationEvaluationOptionDto(value?: unknown): value is EnumerationEvaluationOptionDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(EnumerationEvaluationOptionDtoTypeEnum)[0];
}

export function EnumerationEvaluationOptionDtoFromJSON(json: any): EnumerationEvaluationOptionDto {
    return EnumerationEvaluationOptionDtoFromJSONTyped(json, false);
}

export function EnumerationEvaluationOptionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnumerationEvaluationOptionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'origin': json['origin'] == null ? undefined : EntityOriginFromJSON(json['origin']),
        'isEnabled': json['isEnabled'] == null ? undefined : json['isEnabled'],
        'evaluationState': json['evaluationState'] == null ? undefined : CreateEnumerationEvaluationOptionDtoEvaluationStateFromJSON(json['evaluationState']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function EnumerationEvaluationOptionDtoToJSON(value?: EnumerationEvaluationOptionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'name': value['name'],
        'origin': EntityOriginToJSON(value['origin']),
        'isEnabled': value['isEnabled'],
        'evaluationState': CreateEnumerationEvaluationOptionDtoEvaluationStateToJSON(value['evaluationState']),
        '$type': value['$type'],
    });
}

